if (!customElements.get('bisara-pv-player')) {
  customElements.define('bisara-pv-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const video = this.querySelector('video');
      const button = this.querySelector('.bisara-pro-pv__play');
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('.bisara-pro-pv__close');
      if (!video || !button || !dialog || !close) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        this.previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        video.play().catch(() => {});
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        video.pause();
        document.documentElement.style.overflow = this.previousOverflow || '';
        button.focus({preventScroll:true});
      });
    }
  });
}
